module.exports = __webpack_public_path__ + "static/media/it.pictogram.082bdad0.svg";